import Auth from "../store/auth";
import { MASTER } from '@/constants/funcionarioCargo.js';

import {
    isMultiEmpresa
}
from '@/environment';

const checkInclude = cargos => Auth.getCargoUsuario() === MASTER || cargos.indexOf(Auth.getCargoUsuario()) !== -1;

const createSteps = (steps, perfis) => {
  return steps.filter(step => {
    if (isMultiEmpresa && (step.hasOwnProperty('multiempresa') && !step.multiempresa)) {
      return false;
    } else if (!isMultiEmpresa && (step.hasOwnProperty('multiempresa') && !step.multiempresa)) {
      return checkInclude(step.params.cargos);
    } else if (!isMultiEmpresa && (!step.hasOwnProperty('multiempresa'))) {
      return checkInclude(step.params.cargos);
    } else if (isMultiEmpresa && (step.hasOwnProperty('multiempresa') && step.multiempresa)) {
      return checkInclude(step.params.cargos);
    } else if (!step.hasOwnProperty('multiempresa')){
      return checkInclude(step.params.cargos);
    }
    
    // && $(step.target).val() != undefined && $(step.parent).val() != undefined
    ;
  });
}

export default {
  createSteps
}


// WEBPACK FOOTER //
// ./src/helpers/tour.js